import { LOCAL_STORAGE_KEYS } from "../constants/local-storage-keys";
import type { TCountry } from "../types/outerLayout/common";
import type { TChatbotCountry } from "../types/innerLayout/chatbot";
import { getFromLocalStorage } from "./manageLocalStorage";

const {
  LANGUAGE,
  MERCHANT_ID,
  TOKEN,
  ID,
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  PHONE,
  IS_LIVE,
  PROFILE_TYPE,
  BILLS_ENABLED,
  COUNTRY,
  USER_ID
} = LOCAL_STORAGE_KEYS;

export const getLang = (): "en" | "ar" => {
  return getFromLocalStorage(LANGUAGE) ?? 'en';
};

export const getIsLive = (): boolean | null => {
  return getFromLocalStorage(IS_LIVE);
};

export const getMerchantId = () => {
  return getFromLocalStorage(MERCHANT_ID);
};

export const getMerchantToken = () => {
  return getFromLocalStorage(TOKEN);
};

export const getUserId = () => {
  return getFromLocalStorage(USER_ID);
};

export const getMerchantProfileData = () => {
  const id = getFromLocalStorage(ID);
  const first_name = getFromLocalStorage(FIRST_NAME);
  const last_name = getFromLocalStorage(LAST_NAME);
  const email = getFromLocalStorage(EMAIL);
  const phone = getFromLocalStorage(PHONE);

  return { id, first_name, last_name, email, phone };
};

export const getProfileType = () => {
  return getFromLocalStorage(PROFILE_TYPE);
};

export const isBillsEnabled =() => {
  return getFromLocalStorage(BILLS_ENABLED);
}

export const getCountry = (): TCountry | null => {
  return getFromLocalStorage(COUNTRY);
};

const CHATBOT_COUNTRY_MAP: Partial<Record<TCountry, TChatbotCountry>> = {
  EGY: 'egypt',
  ARE: 'uae',
  OMN: 'oman',
  SAU: 'ksa',
};

export const getChatbotCountry = (): TChatbotCountry => {
  const country = getCountry();
  return country ? CHATBOT_COUNTRY_MAP[country] ?? 'glb' : 'glb';
};
